export default {
    setErklaerungsText(state, erklaerungsText) {
        state.erklaerungsText = erklaerungsText
    },
    setArzneimittelvorschlaege(state, arzneimittelvorschlaege) {
        state.arzneimittelvorschlaege = arzneimittelvorschlaege
    }
}